module.exports = __webpack_public_path__ + "static/img/yiqingtang.4cb0700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Btn/yiqingtang.png
// module id = hFFS
// module chunks = 0